import { INTL_DMY_CASUAL_FORMAT } from 'constants/dateFormats'
import { intlDateFormatter } from 'lib/datetime/dateUtils'
import type { Moment } from 'moment'
import type { IntlShape } from 'react-intl'

interface Params {
  bookBy: Moment
  travelUntil: Moment
}

function getGiftingMessageIntl(params: Params, intl: IntlShape) {
  const { bookBy, travelUntil } = params

  return intl.formatMessage(
    {
      id: 'rIrqp0a6BOm3q8XpqxLm',
      defaultMessage: 'Buy a package and send as a gift to a special someone. They can book by {bookByDate} and travel until {travelUntilDate}.',
      description: 'Gifting helper message explaining booking and travel deadlines',
    },
    {
      bookByDate: intlDateFormatter(bookBy.toDate(), INTL_DMY_CASUAL_FORMAT),
      travelUntilDate: intlDateFormatter(travelUntil.toDate(), INTL_DMY_CASUAL_FORMAT),
    },
  )
}

export default getGiftingMessageIntl
